import React from "react";
import { X } from "lucide-react";
import ConversationThemeSection from "./ConversationThemeSection";
import ConversationNicknameSection from "./ConversationNicknameSection";
import ConversationMediaSection from "./ConversationMediaSection";

export default function ConversationSettingsDrawer({
  open,
  onClose,
  isGroupChat,
  selectedGroup,
  selectedFriend,
  settingsLoading,
  themeKey,
  onSelectTheme,
  myNicknameForPeer,
  nicknamesByUserId,
  currentUserId,
  mediaItems,
  isProbablyGifUrl,
  onRefreshMedia,
  onSaveDmNickname,
  onSaveGroupNickname,
}) {
  if (!open) return null;

  const title = isGroupChat
    ? selectedGroup?.name || "Group chat"
    : selectedFriend?.username || "Direct message";

  return (
    <>
      <button
        type="button"
        className="fixed inset-0 z-[70] bg-black/55 backdrop-blur-[2px]"
        onClick={onClose}
        aria-label="Close settings"
      />
      <aside
        className="fixed inset-y-0 right-0 z-[71] w-full max-w-md border-l border-white/10 bg-[#0a0e16]/96 backdrop-blur-2xl shadow-[-12px_0_40px_rgba(0,0,0,0.45)] flex flex-col"
        role="dialog"
        aria-modal="true"
        aria-labelledby="conv-settings-title"
      >
        <div className="flex items-center justify-between px-5 py-4 border-b border-white/10">
          <h2 id="conv-settings-title" className="text-[16px] font-semibold text-white truncate pr-3">
            {title}
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="h-9 w-9 rounded-xl border border-white/12 bg-white/[0.05] flex items-center justify-center hover:bg-white/[0.1] transition"
            aria-label="Close"
          >
            <X className="text-white/85" size={18} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto fc-scroll px-5 py-5 space-y-8">
          {settingsLoading ? (
            <p className="text-[13px] text-white/50 text-center py-8">Loading settings…</p>
          ) : (
            <>
              <ConversationThemeSection
                themeKey={themeKey}
                onSelectTheme={onSelectTheme}
                disabled={settingsLoading}
              />

              <div className="h-px bg-white/10" />

              <ConversationNicknameSection
                mode={isGroupChat ? "group" : "dm"}
                dmPeerUsername={selectedFriend?.username}
                dmNickname={myNicknameForPeer}
                onSaveDmNickname={onSaveDmNickname}
                groupMembers={selectedGroup?.members || []}
                currentUserId={currentUserId}
                nicknamesByUserId={nicknamesByUserId}
                onSaveGroupNickname={onSaveGroupNickname}
                disabled={settingsLoading}
              />

              <div className="h-px bg-white/10" />

              <ConversationMediaSection
                items={mediaItems}
                isProbablyGifUrl={isProbablyGifUrl}
                onRefresh={onRefreshMedia}
                loading={settingsLoading}
              />
            </>
          )}
        </div>
      </aside>
    </>
  );
}
